import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { TreeItem, TreeView } from '@mui/lab'
import { FC, useEffect, useState } from 'react'

import useSingleInspectionWithRelated from '../../hooks/useSingleInspectionWithRelated/useSingleInspectionWithRelated'

interface Props {
  inspectionId: string
}

const TreePreview: FC<Props> = ({ inspectionId }) => {
  const { inspectionWithRelated: inspection } =
    useSingleInspectionWithRelated(inspectionId)
  const [expanded, setExpanded] = useState<string[]>([])
  const handleToggle = (event: React.SyntheticEvent, nodeIds: string[]) => {
    setExpanded(nodeIds)
  }
  useEffect(() => {
    if (inspection) {
      const temp: string[] = []
      inspection.sections.forEach((section) => {
        temp.push(section.id!)
        section.entries.forEach((entry) => {
          temp.push(entry.id!)
          entry.prompts.forEach((prompt) => {
            temp.push(prompt.id!)
          })
        })
      })
      setExpanded(temp)
    } else {
      setExpanded([])
    }
  }, [inspection])

  return (
    <TreeView
      disableSelection
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      expanded={expanded}
      onNodeToggle={handleToggle}>
      {(inspection?.sections || []).map((section) => (
        <TreeItem
          nodeId={section.id!}
          key={section.id!}
          label={`${section.info!.title!}`}>
          {section.entries.map((entry) => (
            <TreeItem
              nodeId={entry.id!}
              key={entry.id!}
              label={`${entry.info!.title || '(No title)'}`}>
              {entry.prompts!.map((prompt) => (
                <TreeItem
                  nodeId={prompt.id!}
                  key={prompt.id!}
                  label={`${prompt.info!.question!}`}></TreeItem>
              ))}
            </TreeItem>
          ))}
        </TreeItem>
      ))}
    </TreeView>
  )
}

export default TreePreview
